const CONDITIONS = {
  ex: 'Excellent',
  gd: 'Good',
  avg: 'Average',
  pr: 'Poor',
  vpr: 'Very Poor',
};

export default CONDITIONS;
